module.exports = __webpack_public_path__ + "static/img/001.1008343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand/001.png
// module id = EE4T
// module chunks = 1